import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Aplicacao } from './Aplicacao'

import './estilos/tema.css'
import './estilos/dashboard.css'
import './estilos/admin.css'

/**
 * Ponto de entrada.
 *
 * `StrictMode` monta cada componente DUAS vezes em desenvolvimento, de
 * propósito, para denunciar efeito que não se limpa. Num painel que fica 4 dias
 * ligado isso não é incômodo, é a rede de proteção: `EventSource` e
 * `setInterval` que vazam numa remontagem vazariam também em cada troca de
 * visão, e o sintoma só apareceria no terceiro dia do evento.
 */
const raiz = document.getElementById('raiz')
if (!raiz) throw new Error('elemento #raiz não encontrado no index.html')

createRoot(raiz).render(
  <StrictMode>
    <Aplicacao />
  </StrictMode>,
)
